module.exports = __webpack_public_path__ + "img/balance-scale-left.5ec84767.svg";